import * as tslib_1 from "tslib";
import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '../../../core';
var FormlyWrapperLabel = (function (_super) {
    tslib_1.__extends(FormlyWrapperLabel, _super);
    function FormlyWrapperLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormlyWrapperLabel;
}(FieldWrapper));
tslib_1.__decorate([
    ViewChild('fieldComponent', { read: ViewContainerRef }),
    tslib_1.__metadata("design:type", ViewContainerRef)
], FormlyWrapperLabel.prototype, "fieldComponent", void 0);
FormlyWrapperLabel = tslib_1.__decorate([
    Component({
        selector: 'formly-wrapper-label',
        template: "\n    <label [attr.for]=\"id\" class=\"form-control-label\">{{ to.label }}</label>\n    <ng-container #fieldComponent></ng-container>\n  ",
    })
], FormlyWrapperLabel);
export { FormlyWrapperLabel };
//# sourceMappingURL=label.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/wrappers/label.js
// module id = 784
// module chunks = 3